import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=04451c50&scoped=true&"
import script from "./TenantDetail.vue?vue&type=script&lang=js&"
export * from "./TenantDetail.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetail.vue?vue&type=style&index=0&id=04451c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04451c50",
  null
  
)

export default component.exports